import { AvailablePlanExtra } from '@dtx-company/inter-app/src/types/AvailablePlanExtra'
import {
  GetAvailablePlanExtrasOptions,
  getAvailablePlanExtras
} from '@dtx-company/inter-app/src/api/subscription-service/getAvailablePlanExtras'
import {
  UseAPIConfig,
  UseAPIOptions,
  UseAPIResponse,
  useAPI
} from '@dtx-company/inter-app/src/hooks/useAPI'

type UseAvailablePlanExtrasSWROptions = UseAPIOptions<GetAvailablePlanExtrasOptions>
type UseAvailablePlanExtrasSWRConfig = UseAPIConfig<AvailablePlanExtra[] | undefined, Error>
type UseAvailablePlanExtrasSWRResponse = UseAPIResponse<AvailablePlanExtra[] | undefined, Error>

export function useAvailablePlanExtrasSWR(
  options: UseAvailablePlanExtrasSWROptions,
  config?: UseAvailablePlanExtrasSWRConfig
): UseAvailablePlanExtrasSWRResponse {
  return useAPI<GetAvailablePlanExtrasOptions, AvailablePlanExtra[] | undefined, Error>(
    'useAvailablePlanExtrasSWR',
    getAvailablePlanExtras,
    options,
    config
  )
}
